var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.ModuleContainer,
    _vm._b(
      {
        scopedSlots: _vm._u([
          {
            key: "draggable",
            fn: function (props) {
              return [
                _setup.c_show
                  ? _c(
                      _setup.DraggablePopup,
                      _vm._b(
                        {
                          attrs: {
                            show: _setup.c_show,
                            title: _setup.$map.trans(
                              "map.measurement.setting.title"
                            ),
                          },
                          on: {
                            "update:show": function ($event) {
                              _setup.c_show = $event
                            },
                          },
                        },
                        "DraggablePopup",
                        Object.assign(props, _vm.popUpPosition),
                        false
                      ),
                      [
                        _c(
                          "div",
                          { staticClass: "setting-container" },
                          [
                            _c(_setup.MeasurementSettingFields, {
                              attrs: { fields: _vm.fields },
                            }),
                            _c(_setup.FieldGeometry, {
                              attrs: { maxLength: _vm.maxLength },
                              on: { "click:fillbound": _setup.onFlyTo },
                              model: {
                                value: _setup.model,
                                callback: function ($$v) {
                                  _setup.model = $$v
                                },
                                expression: "model",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            },
          },
        ]),
      },
      "ModuleContainer",
      _vm.$attrs,
      false
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }